import React, {useEffect} from "react";
import Styles from './styles.module.scss'

import Seo from "../../../components/_UI/seo";
import {useTranslation} from "react-i18next";

import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import CabinetPreSaleMain from "../../../components/cabinet/cabinetPreSaleMain";
import CabinetPreSaleBuy from "../../../components/cabinet/cabinetPreSaleBuy";
import CabinetPreSaleStatistic from "../../../components/cabinet/cabinetPreSaleStatistic";
import {getOrderHistory, getPreSaleMain} from "../../../store/cabinet/action";
import CabinetPreSaleBuyModal from "../../../components/cabinet/cabinetPreSaleBuyModal";
import CabinetPreSaleHistory from "../../../components/cabinet/cabinetPreSaleHistory";
import CabinetSettingsChangeWalletModal from "../../../components/cabinet/cabinetSettingsChangeWalletModal";




const CabinetPreSalePage = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const authStatus = useSelector(store => store.main.authorizationStatus);

    useEffect(()=>{
        if (!authStatus){
            navigate('/sign-in');
        }
    },[authStatus, navigate])

    useEffect(()=>{
        if (authStatus){
            dispatch(getPreSaleMain());
            dispatch(getOrderHistory());
        }
    },[authStatus, dispatch])

    return (
        <section className={`${Styles.container}`}>
            <Seo title={t('Pre Sale')}/>
            <div className={`${Styles.posWrap}`}>
                <CabinetPreSaleMain/>
                <CabinetPreSaleBuy/>
                <CabinetPreSaleStatistic/>
                <CabinetPreSaleHistory/>
                <CabinetPreSaleBuyModal/>
                <CabinetSettingsChangeWalletModal/>
            </div>
        </section>
    );
};

export default CabinetPreSalePage;